import React from 'react';
import { Badge } from 'react-bootstrap';
import ProductDetailModal from './ProductDetailModal';
import { isCatalogFamilyMatch, getLineProduct } from '../../utils/productOpenProcurement';

/**
 * Variant column for open procurement rows — shows catalog-family badge + line product link.
 *
 * @param {Object} props
 * @param {Object} props.row - open_quotes[] or open_orders[] entry
 * @param {boolean} [props.isSupplier]
 * @param {function} [props.clearSearchValue]
 */
const OpenProcurementVariantCell = ({
  row,
  isSupplier = false,
  clearSearchValue = () => {},
}) => {
  if (!isCatalogFamilyMatch(row)) {
    return <span className="text-muted">—</span>;
  }

  const lineProduct = getLineProduct(row);
  if (!lineProduct) {
    return <span className="text-muted">—</span>;
  }

  const catNum = lineProduct.cat_num || `Product ${lineProduct.id}`;
  const tooltip = lineProduct.name || catNum;

  return (
    <div className="d-flex flex-column align-items-center gap-1">
      <Badge bg="info" title={tooltip}>
        Variant: {catNum}
      </Badge>
      <ProductDetailModal
        isSupplier={isSupplier}
        productId={lineProduct.id}
        clearSearchValue={clearSearchValue}
      />
    </div>
  );
};

export default OpenProcurementVariantCell;
